import { httpRequest } from "../../http";
import { Metric } from "@models/fieldMap.model";
export class CommandListMetrics {
  async run(entityCode: string): Promise<Metric[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/entity-types/${entityCode}/metrics/`;
    return httpRequest<Metric[]>(url, { method: "GET" });
  }
}
